import type { FaireProductEntity } from "../../entity_types/product";

export const p_xqwtdbdq2r: FaireProductEntity = {
  token: "p_xqwtdbdq2r",
  type: "product",
  name: "Hottie Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/f19ca1673891f82876103f9e2356cbf007054b991a0f5685cf9554010cdbf634.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3f039dd88a89f76f78596c8eeeeb3d6753b7c4b1a71cee9be5289decd2ffb6af.jpeg",
    "https://cdn.faire.com/fastly/1ed934f6a642ced3ef183133f7e82dc14da198cfa9c7a6a9216cde55de56b307.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/5dfb678eea7c17d008e07e4c4f87ef81d74d5f9137d3020b38eb94dbf5ca37a4.jpeg",
    "https://cdn.faire.com/fastly/b9dfed930c4046ce1fef47da3c2fa3c9f70afb1f5c5345c5f3b1827c33ad8eaa.jpeg",
    "https://cdn.faire.com/fastly/8d3c5f50a9b0019ad311e02505c6b54e878e5f3973100a988a0006ff15897f40.jpeg",
    "https://cdn.faire.com/fastly/c1b33acb5cfb060a00c5eb4d0f4b17b09dbd779a69d99aaf9a89fa79537df601.jpeg",
    "https://cdn.faire.com/fastly/c0b4c198f2332b844a05d3cd9fc2fbf8a5ab0675fa6b2e24a556bd9c3132ed4e.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are perfect for whoever keeps raising the room temperature just by showing up. 🥵\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:18.217Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
